import { CapitalOsAuthenticationProvider } from "@capitalos/react";
import { useSuspenseQuery } from "@tanstack/react-query";
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { type } from "arktype";
import { Pending } from "@/components/Pending";
import { getSafeRedirectTarget } from "@/lib/redirectUtils";
import { queryClient } from "@/lib/trpcClient";

const validateSearch = type({
  "to?": "string",
});

// Type declaration for pylon chat widget
declare global {
  interface Window {
    pylon?: {
      chat_settings: {
        app_id: string;
        email: string;
        email_hash: string;
        name: string;
        avatar_url?: string;
      };
    };
  }
}
export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ context, location, search }) => {
    const session = await context.queryClient.ensureQueryData(
      context.trpc.auth.session.queryOptions(),
    );

    if (!session.user) {
      const redirectTarget = getSafeRedirectTarget(
        location.pathname,
        search.to,
      );
      throw redirect({
        search: redirectTarget ? { to: redirectTarget } : {},
        to: "/login",
      });
    }
  },
  component: RouteComponent,
  pendingComponent: Pending,
  validateSearch,
});

function RouteComponent() {
  const { trpc } = Route.useRouteContext();
  const { to } = Route.useSearch();
  const navigate = useNavigate();
  const { data } = useSuspenseQuery(trpc.auth.session.queryOptions());
  const location = useLocation();
  // Forcibly navigate due to inactivity
  if (!data.user) {
    const redirectTarget = getSafeRedirectTarget(location.pathname, to);
    return navigate({
      search: redirectTarget ? { to: redirectTarget } : {},
      to: "/login",
    });
  } else {
    window.pylon = {
      chat_settings: {
        app_id: "21c45822-49d7-4cad-a8ee-4913104122b9",
        email: data.user.email,
        email_hash: data.pylonHash,
        name: data.user.name,
        // avatar_url: data.user.,
      },
    };
  }

  return (
    <CapitalOsAuthenticationProvider
      getToken={async () => {
        // @ts-ignore
        return await queryClient.fetchQuery(
          trpc.auth.capitalSession.queryOptions(),
        );
      }}
    >
      <Outlet />
    </CapitalOsAuthenticationProvider>
  );
}
